import { axiosInstance } from '../Config/axios';

const PROFILE_URL = 'v1/profile/';

export const updateDataProfile = async () => {
  try {
    const response = await axiosInstance.put(PROFILE_URL);
    return response.data;
  } catch (error) {
    console.error("Error al modificar los datos del perfil", error);
    throw error;
  }
};

export const updatePhotoProfile = async (formData) => {
  try {
    const response = await axiosInstance.post(`${PROFILE_URL}photo/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al modificar la imagen del perfil", error);
    throw error;
  }
};

export const updatePassword = async (formData) => {
  try {
    const response = await axiosInstance.post(`${PROFILE_URL}password/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al modificar la contraseña", error);
    throw error;
  }
};